export const THOUSAND = 1000

export const CREDIT_LINE_VALIDITY_DAYS = 15

export enum ADVANCE_STATES {
  PREAPPROVED = 'preapproved',
  APPROVED = 'approved',
  DRAFT = 'draft',
  FINISHED = 'finished',
  DELAYED = 'delayed',
  DEFAULTED = 'defaulted',
  SEND = 'send'
}

export const CREDIT_TYPES = {
  ZERO_RATE: 'interest-free-advance',
  DEFAULT: 'cash-advance',
  LOAN: 'personal-loan'
}

export enum CREDIT_LINE_STATE {
  membership = 'membership',
  noMembership = 'no_membership'
}

export const INTEREST_FREE_ADVANCE_MAX_AMOUNT = Number(
  process.env.REACT_APP_INTEREST_FREE_ADVANCE_MAX_AMOUNT
)

export const INSTALLMENT_STATES = {
  PENDING: 'pending',
  PAYED: 'payed',
  LATE: 'late',
  DELAYED: 'delayed'
}

export const MAX_LOAN_AMOUNT = 1250000

const ADVANCE_LINE_LIMIT = Number(process.env.REACT_APP_ADVANCE_LINE_LIMIT)
export const MAX_ADVANCE_AMOUNT = MAX_LOAN_AMOUNT * ADVANCE_LINE_LIMIT

export enum OFFER_ERROR_SLUGS {
  inArrears = 'client_is_in_arrears',
  badScore = 'bad_credit_score',
  noProposalAvailable = 'no_credit_proposal_available',
  lineIsDepleted = 'credit_line_depleted'
}

export enum ATTEMPT_STATUS {
  SUBMITTED = 'SUBMITTED',
  SUBMITTED_WITH_DELAYS = 'SUBMITTED_WITH_DELAYS',
  REJECTED = 'REJECTED'
}
